<template>
    <div style="margin-bottom: 120px;">
      <b-row>
        <b-col lg="8">
            <template v-if="currentPost"> 
                <div v-html="currentPost.FullContent"></div>
            </template>
        </b-col>
        <b-col lg="4">
          <div>
            <RightMenu :postData="getPostData"/>
          </div>
        </b-col>
      </b-row>
    </div>
  </template>
  
  <script>
import RightMenu from '@/layout/RightMenu'
import { mapGetters } from "vuex";
  export default {
      components: {
          RightMenu
      },
      computed:{
        ...mapGetters(["getPostData"]),
        currentPost(){
            if(!this.getPostData) return null
            const currentLink  = this.$route.query?.post
            return this.getPostData.find(item=>item.Link == currentLink)
        }
      },
      methods: {
          handleClick(route){
              this.$router.push(`/guideline/${route}`)
          }
      }
  };
  </script>
  
  <style scoped>
  .separator {
    background: #e6e8ec;
    height: 1px;
  }
  .menu-content {
    color: var(--website-neutral-60, #18191a);
    /* Website & tablet/Menu */
    font-size: 14px;
    font-weight: 400;
    line-height: 16px; /* 114.286% */
    text-transform: uppercase;
  }
  .menu-title {
    color: var(--brand-color, #c71313);
    font-size: 24px;
    font-weight: 600;
    text-transform: uppercase;
  }
  .right-menu {
    border-radius: 24px;
    border: 1px solid var(--website-gray, #e6e8ec);
    background: var(--website-white, #fff);
    padding: 32px;
  }
  .font-64 {
    font-size: 64px;
  }
  .font-24 {
    font-size: 24px;
  }
  .title-block {
    font-size: 12px;
    font-weight: 300;
    color: #636466;
    width: 75%;
  }
  .title-secondary {
    font-size: 16px;
    font-weight: 300;
    color: #636466;
    width: 75%;
    margin-bottom: 40px !important;
  }
  .content-slogan {
    color: var(--website-brand-color, #c71313);
    /* Website & tablet/Header 1 */
    font-size: 48px;
    font-weight: 400;
    line-height: 60px; /* 125% */
    margin-bottom: 40px !important;
  }
  .content-card {
    border: 1px solid #e6e8ec;
    border-radius: 24px;
    overflow: hidden;
    transition: 500ms;
    cursor: pointer;
  }
  .content-card p {
    height: 100px;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .content-card:hover {
    box-shadow: 0px 40px 32px -24px rgba(15, 15, 15, 0.12);
  }
  .mb-40{
    margin-bottom: 40px;
  }
  </style>
  